export default __webpack_public_path__ + "1.17.16/static/media/libreLinkUp-small-ar.34ac38f7.svg";